export const stepOneData = [
  {
    paraOne:
      "Are you paying a high EMI on your car loan? MinEMI’s Car Loan Balance Transfer feature is designed to help you save. Transfer your car loan to a lender offering lower interest rates, reduced EMIs, or better repayment terms and unlock significant savings. Let MinEMI guide you through a smooth, hassle-free process to ensure your car loan works better for your finances.",
    heading: "Why Choose MinEMI for Your Car Loan Balance Transfer?",
    infoList: [
      {
        heading: " Lower Interest Rates:",
        description:
          "MinEMI helps you find lenders offering reduced rates, saving you money on interest costs.",
      },
      {
        heading: "Reduced EMIs:",
        description:
          "Optimize your monthly budget with lower EMIs tailored to your needs.",
      },
      {
        heading: "Flexible Loan Terms:",
        description:
          "Get access to better repayment options, including tenure adjustments.",
      },
      {
        heading: "Expert Guidance: ",
        description:
          "MinEMI simplifies every step, from calculating savings to finalizing the transfer.",
      },
      {
        heading: "Transparency: ",
        description:
          "Enjoy complete clarity on charges, fees, and savings with MinEMI’s tools.",
      },
    ],
  },
  {
    heading: "When to Use MinEMI’s Car Loan Balance Transfer?",
    subheading:
      "Knowing the right time to transfer your car loan can maximize your savings. Here are the ideal situations for using MinEMI’s Car Loan Balance Transfer feature:",
    personal_lone: [
      {
        heading: "After Market Interest Rate Drops:",
        description:
          "If market interest rates are lower than what your current lender offers, it’s the right time to transfer your car loan.",
      },
      {
        heading: "Mid-Tenure of Your Loan:",
        description:
          "Transferring your car loan early or mid-tenure maximizes savings by reducing interest costs over time. MinEMI calculates the best time for a transfer.",
      },
      {
        heading: " Improved Financial Profile:",
        description:
          "If your credit score has improved or your income has increased, lenders may offer you better terms. Use this opportunity to transfer your loan.",
      },
      {
        heading: "High Interest Rate with Current Lender:",
        description:
          "If your current lender is charging higher rates than competitors, transferring your car loan can help you save significantly.",
      },
      {
        heading: " Need for Lower EMIs:",
        description:
          "If your monthly EMIs are too high, transferring your loan to a longer tenure at a lower interest rate can provide relief.",
      },
    ],
  },
];

export const savingCalculator = [
  {
    id: 1,
    title: "Car Loan Balance Transfer Calculator",
    description:
      "Transferring debt to a credit card or loan with a lower interest rate can save you money on interest while you pay off your debt.",
  },
  {
    id: 2,
    inputsHeadingOne: "Your Current Loan",
    inputsHeadingTwo: "Details of Loan",
  },
];

export const helpData = [
  {
    id: 1,
    needhelp: "Need help with this information? Click here",
    title: "Where to find information for the calculator",
    information: [
      {
        id: 1,

        subtitle: "Existing debt: Credit card debt to transfer",
        infotext:
          "You can check your credit card statement for details about the amount you owe. Alternatively, you can log in to your bank or credit card issuer's app or website to view the current outstanding balance. Ensure you use the total outstanding balance instead of the minimum due amount to get accurate results for your balance transfer.",
      },
      {
        id: 2,
        subtitle: "Existing debt: Interest rate",
        infotext:
          "The interest rate applicable on your credit card debt is often referred to as the Annual Percentage Rate (APR) or monthly interest rate in India. This rate can be found in your credit card statement under sections like 'Interest Charges', 'Finance Charges', or the terms and conditions shared with your credit card account. Use the APR to input an accurate value for interest in the calculator.",
      },
      {
        id: 3,
        subtitle: "Balance Transfer Loan: Processing Fee",
        infotext:
          "Most balance transfer loans or credit card balance transfers in India involve a processing fee. This fee is a one-time charge and varies depending on the lender or card issuer. You can find this information in the loan or credit card terms and conditions or by checking the lender’s website. Ensure this fee is factored into the calculation for accurate results.",
      },
      {
        id: 4,
        subtitle: "Balance Transfer Loan: New Interest Rate",
        infotext:
          "The new interest rate for a balance transfer will depend on the offer provided by your new lender or card issuer. This rate is usually lower than the existing interest rate on your current credit card. Check the lender’s website or promotional offers for this rate, often labeled as 'Balance Transfer Interest Rate' or 'Special Rate for Transfers'.",
      },
      {
        id: 4,
        subtitle: "Loan Tenure or Repayment Period",
        infotext:
          "The repayment period is the time you need to repay the transferred balance. This is typically specified by the lender and can vary between 6 to 84 months for personal loans and other credit products in India. For credit card balance transfers, shorter tenures like 3 to 12 months are common.",
      },
    ],
  },
];
